export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY - HH:mm:ss";
export const DATE_TIME_FORMAT_1 = "DD/MM/YYYY HH:mm";
export const DATE_TIME_FORMAT_2 = "YYYY-MM-DDTHH:mm";
export const DATE_FORMAT_YYYYMMDD = "YYYY-MM-DD";

export const ACCESS_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
export const USER_INFO_KEY = "user_info";
export const BUCKET_URL_KEY = "bucket_url";

export const DEBOUNCE_TIMER = 300;
export const MAX_SIZE_UPLOAD = 536870912; // bytes = 512 MB

export enum Role {
  ROOT = "ROLE_ROOT",
  ADMIN = "ROLE_ADMIN",
  ADMIN_ROOT = "ROLE_ADMIN_ROOT",
  USER = "ROLE_USER",
  AUTHOR = "ROLE_AUTHOR",
}

export enum OrderType {
  ASC = "ASC",
  DESC = "DESC",
}

export const ResponseStatus = Object.freeze({
  SUCCESS: "SUCCESS",
});

export enum MenuLabel {
  STATISTICS = "Thống Kê",
  BOOK_MANAGEMENT = "Sách",
  USER_MANAGEMENT = "Người Dùng",
  LOG_MANAGEMENT = "Logs",
  FEED_MANAGEMENT = "Quản lý Feed",
  SQL_EDITOR_MANAGEMENT = "SQL Editor",
  BOOK_TIME_MANAGEMENT = "Cài đặt khung giờ",
  CATEGORY_MANAGEMENT = "Danh Mục",
  BANNER_MANAGEMENT = "Banner",
  AFFILIATE_CAMPAIGN_MANAGEMENT = "Campaign Affiliate",
  ADVERTISE_MANAGEMENT = "Quảng cáo",
  BACKGROUND_MUSIC_MANAGEMENT = "Nhạc Nền",
  TRANSACTION_MANAGEMENT = "Giao Dịch",
  TRANSFER_HISTORY_MANAGEMENT = "Lịch Sử Rút Tiền",
  BANK_MANAGEMENT = "Ngân Hàng",
  VOUCHER_IMPORT = "Nhập Mã Giảm Giá",
  ACCOUNT_INFO = "Thông Tin Tài Khoản",
  CONTENT_MANAGEMENT = "Nội Dung",
  NOTIFICATION_MANAGEMENT = "Notification",
  SETTING_MANAGEMENT = "Setting",
  CAMPAIGN_MANAGEMENT = "Campaign",
  VOUCHER_ACTIVE_MANAGEMENT = "Voucher Active",
  ALERT_SYSTEM_MANAGEMENT = "Thông Báo Hệ Thống",
  SETTING_UI_MANAGEMENT = "Cấu hình giao diện",
  MEDIA_MANAGEMENT = "Media",
  BOOK_SEGMENT_MANAGEMENT = "Book Segment",
  AUTHOR_BANK = "Liên Kết Ngân Hàng",
}

export enum RoutePath {
  SIGN_IN = "/login",
  GOOGLE_CONSOLE = "/google-console",
  HOME = "/",
  STATISTICS = "/statistics",
  BOOK_MANAGEMENT = "book-management",
  USER_MANAGEMENT = "user-management",
  LOG_MANAGEMENT = "log-management",
  FEED_MANAGEMENT = "feed-management",
  UPDATE_FEED = "update-feed",
  UPDATE_FEED_ID = "update-feed/:feedId",
  COMMENT_FEED_MANAGEMENT = "update-feed/:feedId/comments",
  SQL_EDITOR_MANAGEMENT = "sql-editor-management",
  BOOK_TIME_MANAGEMENT = "book-time-management",
  CREATE_BOOK_TIME = "create-book-time",
  UPDATE_BOOK_TIME = "update-book-time",
  UPDATE_BOOK_TIME_ID = "update-book-time/:bookTimeId",
  CATEGORY_MANAGEMENT = "category-management",
  BANNER_MANAGEMENT = "banner-management",
  CREATE_BANNER = "create-banner",
  UPDATE_BANNER = "update-banner",
  UPDATE_BANNER_ID = "update-banner/:bannerId",
  AFFILIATE_CAMPAIGN_MANAGEMENT = "affiliate-campaign-management",
  CREATE_AFFILIATE_CAMPAIGN = "create-affiliate-campaign",
  UPDATE_AFFILIATE_CAMPAIGN = "update-affiliate-campaign",
  UPDATE_AFFILIATE_CAMPAIGN_ID = "update-affiliate-campaign/:affiliateCampaignId",
  BACKGROUND_MUSIC_MANAGEMENT = "background-music-management",
  TRANSACTION_MANAGEMENT = "transaction-management",
  TRANSFER_HISTORY_MANAGEMENT = "transfer-history-management",
  BANK_TRANSFER_STATEMENT_MANAGEMENT = "bank-transfer-statement-management",
  BANK_MANAGEMENT = "bank-management",
  CREATE_BOOK = "create-book",
  UPDATE_BOOK = "update-book",
  UPDATE_BOOK_ID = "update-book/:bookId",
  BOOK_DETAIL = "book",
  OTP = "otp",
  VOUCHER_IMPORT = "voucher-import",
  ACCOUNT_INFO = "account-info",
  CONTENT_MANAGEMENT = "content-management",
  UPDATE_USER = "update-user",
  UPDATE_USER_ID = "update-user/:userId",
  NOTIFICATION_MANAGEMENT = "notification-management",
  CREATE_NOTIFICATION = "create-notification",
  SETTING_MANAGEMENT = "setting-management",
  UPDATE_SETTING = "update-setting",
  UPDATE_SETTING_ID = "update-setting/:settingId",
  CAMPAIGN_MANAGEMENT = "campaign-management",
  CREATE_CAMPAIGN = "create-campaign",
  UPDATE_CAMPAIGN = "update-campaign",
  UPDATE_CAMPAIGN_ID = "update-campaign/:campaignId",
  VOUCHER_ACTIVE_MANAGEMENT = "voucher-active-management",
  ALERT_SYSTEM_MANAGEMENT = "alert-system-management",
  SETTING_UI_MANAGEMENT = "setting-ui-management",
  ADVERTISE_MANAGEMENT = "advertise-management",
  CREATE_ADVERTISE = "create-advertise",
  UPDATE_ADVERTISE = "update-advertise",
  UPDATE_ADVERTISE_ID = "update-advertise/:advertiseId",
  MEDIA_MANAGEMENT = "media-management",
  BOOK_SEGMENT_MANAGEMENT = "book-segment-management",
  AUTHOR_BANK = "author-bank",
}
